import { render, staticRenderFns } from "./LayoutInApp.vue?vue&type=template&id=cc6eda7a&scoped=true"
import script from "./LayoutInApp.vue?vue&type=script&lang=js"
export * from "./LayoutInApp.vue?vue&type=script&lang=js"
import style0 from "./LayoutInApp.vue?vue&type=style&index=0&id=cc6eda7a&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc6eda7a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Mobaxe\\Nevo.SimAdmin.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cc6eda7a')) {
      api.createRecord('cc6eda7a', component.options)
    } else {
      api.reload('cc6eda7a', component.options)
    }
    module.hot.accept("./LayoutInApp.vue?vue&type=template&id=cc6eda7a&scoped=true", function () {
      api.rerender('cc6eda7a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layouts/LayoutInApp.vue"
export default component.exports